import React, { useState, useEffect } from 'react';
import { Form, Button, Upload, message, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import { toFormData } from '../../util/FormData';
import InputRules from '../../data/InputRules';

const layout = {
	labelCol: {
		span: 4,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 4,
		span: 16,
	},
};
const uploadButton = (
	<div>
		<PlusOutlined />
		<div style={{ marginTop: 8 }}>Upload</div>
	</div>
);

const SliderImagePostForm = ({ addSliderImage }) => {
	const [filelist, setFileList] = useState([]);
	const [imageList, setImageList] = useState([]);

	useEffect(() => {
		if (filelist.length) {
			const file = filelist[filelist.length - 1].originFileObj;
			file.thumbUrl = URL.createObjectURL(file);
			const list = imageList;
			list.push(file);
			setImageList(list);
		}
	}, [filelist]);

	const onFinish = async (values) => {
		values.webImage = imageList[0];
		const data = toFormData(values);
		await addSliderImage(data);
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	const handleChange = ({ fileList }) => {
		setFileList(fileList);
	};

	return (
		<Form
			{...layout}
			name="SliderImagePostForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item label="Upload Web Image" name="webImage">
				<Upload
					accept=".jpg,.png,.jpeg"
					listType="picture-card"
					onChange={handleChange}
					fileList={filelist}
					beforeUpload={() => false}
					maxCount={1}
				>
					{uploadButton}
				</Upload>
			</Form.Item>
			<Form.Item
				label="Priority"
				name={['priority']}
				rules={InputRules.required('Please enter priority from 1 to 10!')}
			>
				<Input placeholder="Enter Priority" />
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Add Slider Image
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
	addSliderImage: (body) => dispatch(Actions.addSliderImage(body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SliderImagePostForm);
